/**
 *
 * MobileTeacherHeader
 *
 */

import React, { memo, useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { compose } from 'redux';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';

// styles
import './style.scss';

// antd component
// import { Button } from 'antd';
// import { NavBar } from 'antd-mobile';

import { useTranslation} from "react-i18next";

// assets
import { MenuOutlined, PlusOutlined } from '@ant-design/icons';
// import CustomIcons from 'components/CustomIcons';

// components
import SchoolPreview from 'mobile/components/SchoolPreview';

// global user
import { withUser } from 'engine/Contexts/User.context';

import { useAuthRole } from 'utils/hooks';
import _local from 'utils/localStorageUtils';

function MobileTeacherHeader({
  visibility,
  collapse,
  roles,
  user,
  // default props
  className,
}) {
  const { t, i18n } = useTranslation();

  const localUser = _local.getLocalUser();
  const roleClass = localUser?.role ? localUser?.role : "";
  const language = localStorage.getItem('i18nextLng') || process.env.DEFAULT_LANGUAGE || "fr";

  const location = useLocation();
  const containerRef = useRef(null);
  const activeItemRef = useRef(null);

  const [schoolsNotif, setSchoolsNotif] = useState(false);
  const [schoolsList, setSchoolsList] = useState(false);
  const [activeSchool, setActiveSchool] = useState(false);

  const [touchStartX, setTouchStartX] = useState(0);
  const [touchEndX, setTouchEndX] = useState(0);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [maxScrollPosition, setMaxScrollPosition] = useState(1);
  const [isDragging, setIsDragging] = useState(false);
  const [loading, setLoading] = useState(false);

  const MIN_DISTANCE = 5;
  const CONTAINER_PADDING = 15;
  const CONTAINER_SCROLL_STEP = !collapse ? 100 : 150;

  const childClassNames = classNames(
    'layout-header-teacher',
    roleClass,
    className,
  );

  // INFO: disable ability to change language based on school language, latest changes from client on 02.2024
  /* const chageLanguage = useCallback(lang => { 
    if (lang != i18n.language) { 
      i18n.changeLanguage(!!lang && lang || language); 
    }
  }, [i18n.language, language]); */

  const changeActiveSchool = useCallback((school) => { 
    if (!!school && school?.key != activeSchool?.key) { 
      setActiveSchool(school);
      // INFO: disable ability to change language based on school language, latest changes from client on 02.2024
      //chageLanguage(school?.language);
      _local.setLocalSchool(school);
    }
  }, [i18n.language, language, activeSchool]);

  /* Load scools and set active school on first load */
  useEffect(() => {
    // active item
    const localActiveSchool = _local.getLocalSchool();
    const school = (!!localActiveSchool && localActiveSchool) || user?.schools?.[0];
    changeActiveSchool(school);
    // list
    setSchoolsList(user?.schools);
  }, []);

  /* Load scools and set active school if schools list inside context is chaged */
  useEffect(() => {
    // active item
    if (!!!activeSchool) {
      const localActiveSchool = _local.getLocalSchool();
      const school = (!!localActiveSchool && localActiveSchool) || user?.schools?.[0];
        changeActiveSchool(school);
    }
    // reset schools list only if we have logging user
    if (!!user?._id) {
      setSchoolsList(user?.schools);
    }
  }, [user?.schools]);

  useEffect(() => {
    setSchoolsNotif(user?.schoolsNotifications);
  }, [user?.schoolsNotifications]);

  // If pathname is changes than we scroll to the active list item
  useEffect(() => {
    if (!!containerRef?.current && !!activeItemRef?.current) {
      containerRef.current.scrollTo({
        left: activeItemRef?.current?.offsetLeft - CONTAINER_PADDING,
        behavior: "smooth",
      });
    }
  }, [location.pathname]);

  // Init scrollbar container and set max positin for scrolling
  useEffect(() => {
    if (!!containerRef?.current) {
      setMaxScrollPosition(
        containerRef?.current?.scrollWidth - containerRef?.current?.clientWidth
      );
      return () => {
        setIsDragging(false);
      }
    }
  }, [containerRef]);

  useEffect(() => {
    setIsDragging(loading);
  }, [loading]);

  const handleSchoolClick = (school, index) => {
    setLoading(true);
    user.changeSchoolByKey(school?.key).then(result => {
      changeActiveSchool(result || school);
      setLoading(false);
    }).catch(err => {
      console.error(err);
      changeActiveSchool(school);
      setLoading(false);
    });
  };

  const onMountedItemList = useCallback((ref) => {
    activeItemRef.current = ref?.current || null;
    if (!!containerRef?.current && !!ref?.current && !isDragging) {
      containerRef.current.scrollTo({
        left: ref?.current?.offsetLeft - CONTAINER_PADDING,
        behavior: "smooth",
      });
    }
  }, [activeItemRef, isDragging]);
  const handleContainerScroll = (e) => {
    setIsDragging(true);
    setScrollPosition(e.target.scrollLeft);
    setMaxScrollPosition(
      e.target.scrollWidth - e.target.clientWidth
    );
  };
  const handleTouchStart = (e) => {
    setIsDragging(false);
    const touchStart = e.touches[0].clientX;
    setTouchStartX(touchStart);
  };
  const handleTouchMove = (e) => {
    setIsDragging(true);
    const touchEnd = e.touches[0].clientX;
    setTouchEndX(touchEnd);
  };
  const handleTouchEnd = (e) => {
   // const distance = e.changedTouches[0].clientX - touchStartX;
    const distance = touchEndX - touchStartX;
    if (distance < MIN_DISTANCE ) {
      // click
      // console.log("Click", isDragging, distance);
    } else {
      // swipe
      // console.log("Swipe", isDragging, distance);
      if (distance > 0) {
        !!containerRef?.current && containerRef?.current.scrollTo({
          left: scrollPosition - CONTAINER_SCROLL_STEP,
          behavior: "smooth",
        });
      } else {
        !!containerRef?.current && containerRef?.current.scrollTo({
          left: scrollPosition + CONTAINER_SCROLL_STEP,
          behavior: "smooth",
        });
      }
      setIsDragging(false);
    }
  };
  const handleArrowClick = (direction) => {
    setIsDragging(true);
    if (direction === 'left') {
      !!containerRef?.current && containerRef?.current.scrollTo({
        left: scrollPosition - CONTAINER_SCROLL_STEP,
        behavior: "smooth",
      });
    } else {
      !!containerRef?.current && containerRef?.current.scrollTo({
        left: scrollPosition + CONTAINER_SCROLL_STEP,
        behavior: "smooth",
      });
    }
    setIsDragging(false);
  };

  const addNewSchool = useMemo(() => (
    <div
      className="add-new-school"
    >
      <PlusOutlined />
    </div>
  ), []);

  const renderList = useMemo(() => {
    return !!schoolsList ? (
      <div
        className="mobile-school-menu"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        onScroll={handleContainerScroll}
        ref={containerRef}
      >
        {schoolsList?.map((school, index) => {
          return (
            <SchoolPreview
              key={`side-menu-std-info-${school?.key}`}
              view="small"
              collapse={collapse}
              loading={loading}
              isActive={school?.key == activeSchool?.key}
              school={school}
              notifications={schoolsNotif}
              showChangeButton={false}
              onClick={() => {
                handleSchoolClick(school, index)
              }}
              onMount={(ref) => onMountedItemList(ref)}
            />
          );
        })}
       {/* {addNewSchool} */}
      </div>
    ) : (
      <div className="mobile-school-menu" ref={containerRef}>
        <SchoolPreview
          key={`side-menu-std-info-${activeSchool?.key}`}
          view="small"
          collapse={collapse}
          loading={loading}
          isActive={activeSchool?.key}
          school={activeSchool}
          notifications={schoolsNotif}
          showChangeButton={false}
          onClick={() => {
            handleSchoolClick(activeSchool, index)
          }}
          onMount={(ref) => onMountedItemList(ref)}
        />
        {/* {addNewSchool} */}
      </div>
    );
  }, [user?.activeSchool, activeSchool, user?.schools, schoolsList, containerRef, collapse, schoolsNotif, loading]);

  // TODO: manage isPublicPath() on another way, add additional hook or similar
  return (!!useAuthRole(roles) && !!visibility) && (
    <div className={classNames(
      collapse && 'collapsed',
      loading && 'loading',
      childClassNames
    )}>
      <span
        className={classNames(
          "horizontal-menu-arrow left",
          scrollPosition === 0 && 'hide'
        )}
        onClick={() => handleArrowClick('left')}
      ></span>

      {renderList}

      <span
        className={classNames(
          "horizontal-menu-arrow right",
          scrollPosition === maxScrollPosition && "hide"
        )}
        onClick={() => handleArrowClick('right')}
      ></span>
    </div>
  );
}

MobileTeacherHeader.defaultProps = {
  visibility: true,
  collapse: false,
  roles: ["teacher"],
};

export default compose(
  withUser,
)(MobileTeacherHeader);
